var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileLinesSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 36,
    height: 36,
    rx: 7.8646,
    fill: "#00389C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 11.8756 6.05 C 10.2013 6.05 8.84 7.4113 8.84 9.0856 V 27.2995 c 0 1.6743 1.3613 3.0356 3.0356 3.0356 H 24.0182 c 1.6743 0 3.0356 -1.3613 3.0356 -3.0356 V 13.6391 H 20.9826 c -0.8395 0 -1.5178 -0.6783 -1.5178 -1.5178 V 6.05 H 11.8756 z M 20.9826 6.05 V 12.1213 H 27.0539 L 20.9826 6.05 z M 14.1524 18.1926 H 21.7415 c 0.4174 0 0.7589 0.3415 0.7589 0.7589 s -0.3415 0.7589 -0.7589 0.7589 H 14.1524 c -0.4174 0 -0.7589 -0.3415 -0.7589 -0.7589 s 0.3415 -0.7589 0.7589 -0.7589 z m 0 3.0356 H 21.7415 c 0.4174 0 0.7589 0.3415 0.7589 0.7589 s -0.3415 0.7589 -0.7589 0.7589 H 14.1524 c -0.4174 0 -0.7589 -0.3415 -0.7589 -0.7589 s 0.3415 -0.7589 0.7589 -0.7589 z m 0 3.0356 H 21.7415 c 0.4174 0 0.7589 0.3415 0.7589 0.7589 s -0.3415 0.7589 -0.7589 0.7589 H 14.1524 c -0.4174 0 -0.7589 -0.3415 -0.7589 -0.7589 s 0.3415 -0.7589 0.7589 -0.7589 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileLinesSolid);
export default __webpack_public_path__ + "static/media/fileLinesSolid.cbeda05af344672a26152b64a20624f5.svg";
export { ForwardRef as ReactComponent };